import MediaService from 'src/services/MediaService'
import AnalyticsService from '@/services/AnalyticsService'

export const setVersion = (state, data) => {
  state.version.build = data.build
  state.version.date = data.date
}

// **************************************************
//
// LOADING
//
// **************************************************
export const setLoadProgress = (state, progress) => {
  state.loading.progress = Math.min(progress, 1)
}
export const setLoadStep = (state, step) => {
  state.loading.step = step
  console.log('setLoadStep', step)
}
export const setLoadComplete = (state) => {
  state.loading.progress = 1
  state.loading.completed = true
}

// **************************************************
//
// ROUTE
//
// **************************************************
export const setRoute = (state, params) => {
  state.route.prev.parent = state.route.curr.parent
  state.route.prev.child = state.route.curr.child

  state.route.curr.parent = params.parent
  state.route.curr.child = params.child

  state.app_state = params.child ? params.child : params.parent
}

export const setRouteAfterLoad = (state, value) => {
  console.log('setafterload', value)
  state.route.afterLoad = value
}

// **************************************************
//
// GATES
//
// **************************************************
export const setPassedAgeGate = (state) => {
  state.passedAgeGate = true
  window.localStorage.setItem('_passedAgeGate', true)
}

export const setPassedTermsGate = (state) => {
  state.passedTermsGate = true
  window.localStorage.setItem('_passedTermsGate', true)
}

// **************************************************
//
// UI
//
// **************************************************
export const setTapped = (state) => {
  state.tapped = true
}

export const toggleMuted = (state) => {
  state.muted = !state.muted
  MediaService.muted = state.muted
}

export const toggleSubtitles = (state) => {
  state.showSubtitles = !state.showSubtitles
}

export const setMode = (state, mode) => {
  state.mode = mode
}
export const toggleMode = (state) => {
  state.mode = 1-state.mode
  if (state.mode === 1)
    AnalyticsService.sendPageview('/scene/kids')
  else
    AnalyticsService.sendPageview('/scene/adults')
}

export const setSceneProgress = (state, sceneProgress) => {
  state.sceneProgress = sceneProgress
}
export const setMapProgress = (state, mapProgress) => {
  state.mapProgress = mapProgress
}

export const addToGallery = (state, img) => {
  state.gallery.unshift(img)
}

export const openMenu = (state) => {
  state.showMenu = true
  state.modeLock = true
  AnalyticsService.sendEvent('menu', 'click', `button-menu`)
}
export const closeMenu = (state) => {
  state.showMenu = false
  state.modeLock = false
}

export const toggleDestInfo = (state) => {
  state.showDestInfo = !state.showDestInfo
}

export const openGallery = (state) => {
  state.showGallery = true
  state.modeLock = true
}
export const closeGallery = (state) => {
  state.showGallery = false
  state.modeLock = false
}

export const openQRPage = (state) => {
  state.showQRPage = true
}
export const closeQRPage = (state) => {
  state.showQRPage = false
}

export const setLoadAframe = (state, val) => {
  state.loadAframe = val
}
export const setLoadScene = (state, val) => {
  state.loadScene = val
}
export const setSceneLoadProgress = (state, sceneProgress) => {
  state.loadSceneProgress = sceneProgress
}
export const setCamZoom = (state, val) => {
  state.camZoom = val
}
export const setCamDistort = (state, val) => {
  state.camDistort = val
}

export const setSceneEntered = (state, val) => {
  state.sceneEntered = val
}
export const setSceneComplete = (state, val) => {
  state.sceneComplete = val
}

export const setCurrSceneIdx = (state, val) => {
  state.currSceneIdx = val
}

export const setModeSwitching = (state, val) => {
  state.modeSwitching = val
}

export const lockMode = (state) => {
  state.modeLock = true
}
export const unlockMode = (state) => {
  state.modeLock = false
}
export const setBgm = (state, bgm) => {
  state.bgm = bgm
}
export const playBgm = (state) => {
  state.bgm.play()
}
export const pauseBgm = (state) => {
  state.bgm.pause()
}

export const setTutorProgress = (state, val) => {
  state.tutorProgress = val
}
export const setTutorTouchX = (state, val) => {
  state.tutorTouchX = val
}
export const setTutorTouchY = (state, val) => {
  state.tutorTouchY = val
}
